import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Modal.scss'


class Modal extends PureComponent {

  static propTypes = {
    onClose: PropTypes.func,
    closeBtn: PropTypes.bool,
    fullWidth: PropTypes.bool,
  }

  static defaultProps = {
    onClose: () => {},
    closeBtn: true,
    fullWidth: false,
  }

  componentDidMount() {
    document.addEventListener('keydown', this.close)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.close)
  }

  close = ({ keyCode }) => {
    const { closeBtn, onClose } = this.props

    if (closeBtn && keyCode === 27) {
      onClose()
    }
  }

  click = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }

  render() {
    const { children, className, containerClassName, textContainerClassName, closeBtn, onClose, fullWidth } = this.props

    const modalWrapperStyleName = cx(s.modalWrapper, className, {
      [s.fullWidth]: fullWidth,
    })

    return (
      <div className={modalWrapperStyleName} onClick={onClose}>
        <div className={cx(s.container, containerClassName)} onClick={this.click}>
          <div className={s.content}>
            <div className={cx(s.textContainer, textContainerClassName)}>
              {children}
            </div>
          </div>
          {
            closeBtn && (
              <span className={s.closeBtn} onClick={onClose} />
            )
          }
        </div>
      </div>
    )
  }
}


export default Modal